/**
 * Engagement Tracker Plugin for Nuxt
 * Automatically loads engagement tracking in client-side
 */

export default function ({ app, isDev }) {
  // Only load on client-side
  if (!process.client) return;

  // Initialize engagement tracker after GTM is ready
  const initEngagementTracker = () => {
    import('@/utils/engagement-tracker').then((module) => {
      const EngagementTracker = module.EngagementTracker;

      // Create Analytics Manager interface for the engagement tracker
      const analyticsInterface = {
        trackEngagement: (type, data) => {
          if (window.$analytics) {
            window.$analytics.track(type, data);
          }
        },

        viewItem: (itemId, context) => {
          if (window.$analytics) {
            window.$analytics.track('view_item', {
              item_id: itemId,
              view_context: context
            });
          }
        }
      };

      // Initialize the tracker
      const tracker = new EngagementTracker(analyticsInterface);

      // Make it globally available
      if (typeof window !== 'undefined') {
        window.engagementTracker = tracker;
      }

      // Add to app context
      app.engagementTracker = tracker;

      console.log(
        '%c📊 Engagement Tracker loaded!',
        'background: #2196f3; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;'
      );

    }).catch(error => {
      console.warn('[Engagement Tracker] Failed to load:', error);
    });
  };

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngagementTracker);
  } else {
    // DOM is already ready
    initEngagementTracker();
  }
}